<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const drawer = computed(() => store.state.project.drawer)
const toggleDrawer = () => store.dispatch('project/toggleDrawer')
</script>

<template>
  <v-app-bar-nav-icon
    x-small
    height="36"
    width="36"
    color="white"
    class="mx-1 pl-4 no-overlay"
    :ripple="false"
    :icon="drawer ? 'mdi-close' : 'mdi-menu'"
    @click="toggleDrawer()"
  ></v-app-bar-nav-icon>
</template>

<style scoped>
.no-overlay :deep(.v-btn__overlay) {
  display: none;
}
</style>
